import React from 'react';
import PropTypes from 'prop-types';
import { AddIcon, CloseIcon } from '$partials/icon';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const Filter = ({ className, title, selected, singleSelect, ...remainingProps }) => {
    const bgColor = selected ? 'bg-black' : 'bg-peach';

    return (
        <div
            className={`link-reset cursor-pointer inline-flex items-center px5 py2 ${bgColor} ${className ? className : ''}`}
            {...remainingProps}>
            <p className={`type-style-5 ${selected ? 'white' : 'black'}`}>{title}</p>

            {!singleSelect &&
                <span
                    aria-hidden={true}
                    className={`ml5 font-0 line-height-0 ${selected ? 'white' : 'black'}`}>
                    {selected ? <CloseIcon/> :<AddIcon/> }
                </span>
            }
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    as: PropTypes.string,
    className: PropTypes.string,
    selected: PropTypes.bool,
    singleSelect: PropTypes.bool,
    title: PropTypes.string,
};

Filter.propTypes = propTypes;

export default Filter;
